import React from "react"
// import Form from "./form"
import WebriQForm from "@webriq/gatsby-webriq-form"

class ContactForm extends React.Component {
  render() {
    return (
      <div>
        <WebriQForm
          data-form-id="9554371d-7f86-4323-9766-ee4ad7ff3e1d"
          className="contact-form"
          data-thankyou-url="/thank-you"
        >
          <h2 className="mb-5 text-center">
            Request a phone call to schedule an appointment
          </h2>
          <div className="form-row">
            <div className="col-md-6">
              <div className="form-group" >
                <input
                  className="form-control mb-3"
                  type="text"
                  name="First and Last Name"
                  id="full_name"
                  required
                  placeholder="First and Last Name"
                  style={{border: '1px solid', height: '60px', boxShadow: '0px 1px 3px 1px grey'}}
                />
                {/* <label htmlFor="full_name" style={{ fontSize: "20px" }}>
                  First and Last Name<sup>*</sup>
                </label> */}
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <input
                  className="form-control mb-3"
                  type="text"
                  name="Phone Number"
                  id="Phone Number"
                  required
                  style={{border: '1px solid', height: '60px', boxShadow: '0px 1px 3px 1px grey'}}
                  placeholder="Phone Number"
                />
                {/* <label htmlFor="Phone Number" style={{ fontSize: "20px" }}>
                  Phone Number<sup>*</sup>
                </label> */}
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <input
                  className="form-control mb-3"
                  type="text"
                  name="Email address"
                  id="Email address"
                  style={{border: '1px solid', height: '60px', boxShadow: '0px 1px 3px 1px grey'}}
                  required
                  placeholder="Email"
                />
                {/* <label htmlFor="Email address" style={{ fontSize: "20px" }}>
                  Email address<sup>*</sup>
                </label> */}
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <input
                  className="form-control mb-3"
                  type="text"
                  name="Your Location (City and State)"
                  id="ylocation"
                  required
                  style={{border: '1px solid', height: '60px', boxShadow: '0px 1px 3px 1px grey'}}
                  placeholder="Your Location (City and State) *"
                />
                {/* <label htmlFor="ylocation" style={{ fontSize: "20px" }}>
                  Your Location (City and State)<sup>*</sup>
                </label> */}
              </div>
            </div>
            <div className="col-md-12 my-5">
              <div className="form-group">
                <textarea
                  className="form-control mb-3"
                  type="text"
                  name="Would You Like to Setup an Orthopedic Appointment?"
                  id="appointment"
                  required
                  style={{border: '1px solid',boxShadow: '0px 1px 3px 1px grey', height: '100px'}}
                  placeholder="Would You Like to Setup an Orthopedic Appointment?*"
                />
                {/* <label htmlFor="appointment" style={{ fontSize: "20px" }}>
                  Would You Like to Setup an Orthopedic Appointment?<sup>*</sup>
                </label> */}
              </div>
            </div>
            {/* <div className="col-md-12">
              <fieldset>
                <legend>
                  What kind of problem is your pet having?<sup>*</sup>
                </legend>
                <input
                  type="checkbox"
                  className="mr-2"
                  name="Problems does your pet have"
                  value="Limping on a front limb"
                />
                Limping on a front limb
                <br />
                <input
                  type="checkbox"
                  className="mr-2"
                  name="Problems does your pet have"
                  value="Limping on a rear limb"
                />
                Limping on a rear limb
                <br />
                <input
                  type="checkbox"
                  className="mr-2"
                  name="Problems does your pet have"
                  value="Having a neurologic problem"
                />
                Having a neurologic problem
                <br />
                <input
                  type="checkbox"
                  className="mr-2"
                  name="Problems does your pet have"
                  value="Been diagnosed with an ACL tear"
                />
                Been diagnosed with an ACL tear
                <br />
                <input
                  type="checkbox"
                  className="mr-2"
                  name="Problems does your pet have"
                  value="Been diagnosed with hip dysplasia"
                />
                Been diagnosed with hip dysplasia
                <br />
                <input
                  type="checkbox"
                  className="mr-2"
                  name="Problems does your pet have"
                  value="Been diagnosed with an elbow or shoulder problem"
                />
                Been diagnosed with an elbow or shoulder problem
                <br />
                <input
                  type="checkbox"
                  className="mr-2"
                  name="Problems does your pet have"
                  value="Not sure"
                />
                Not sure
              </fieldset>
            </div> */}
            {/* <div className="col-md-12 mt-5">
              <div className="form-group">
                <textarea
                  className="form-control border-top-0 border-left-0 border-right-0 border-bottom mb-3"
                  name="Phone # with Area"
                  id="phone-number"
                  required
                />
                <label htmlFor="phone-number" style={{ fontSize: "20px" }}>
                  Phone Number w/ Area
                </label>
              </div>
            </div> */}
            <div className="col-md-12">
              <div className="centered-captcha">
                <div className="webriq-recaptcha" />
              </div>
            </div>
            <div className="col-md-8 col-sm-12 m-auto pt-5">
              <div className="form-group text-center">
                <p>
                  <strong>
                    *Please note, we make every effort to contact you as soon as
                    possible, however, if your matter is urgent we suggest
                    calling us at{" "}
                    <a className="tel-link" href="tel:719-264-6666">
                      719-264-6666
                    </a>
                    .
                  </strong>
                </p>
                <div>
                  <button
                    className="btn btn-primary pink-btn border-0"
                    type="submit"
                  >
                    Send Message
                  </button>
                </div>
              </div>
            </div>
          </div>
        </WebriQForm>
      </div>
    )
  }
}
export default ContactForm
